// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nxer","delete":"styles_delete__3EDgm","update":"styles_update__A6Q3b","add":"styles_add__2Kf_p"};